@if (selectedCategoryLabel()) {
    <div class="document-link-area__container"
         [class.document-link-area__container--active]="isDragOver()"
         (dragenter)="onDragEnter($event)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">
    @if (selectedCategoryParentLabel()) {
    <div class="document-link-area__parent" [title]="selectedCategoryParentLabel()">
        <i class="pi pi-folder-open document-link-area__parent-icon" aria-hidden="true"></i>
        <span class="document-link-area__parent-name">{{ selectedCategoryParentLabel() }}</span>
    </div>
    }
    <div class="document-link-area__title" [title]="selectedCategoryLabel()">{{ selectedCategoryLabel() }}</div>
    <div class="document-link-area__dropzone">
        <div class="document-link-area__dropzone-icon-circle">
            <i class="pi pi-link document-link-area__dropzone-icon"></i>
        </div>
        <p class="document-link-area__dropzone-text">Jogcím rendeléshez húzza ide a fájlokat.</p>
    </div>
    <div class="document-link-area__linked-files">
        @for (file of linkedFiles(); track file.name) {
            <div class="document-link-area__linked-file">
                <div class="document-link-area__linked-file-left">
                    <p-checkbox [value]="file" [ngModel]="selectedFiles()" (ngModelChange)="selectedFiles.set($event)" [binary]="false" />
                    <span class="document-link-area__linked-file-dot" [style.background]="file.statusColor"></span>
                    <app-svg-icon class="document-link-area__linked-file-icon" [name]="getFileIcon(file.extension)" [size]="20" />
                    <span class="document-link-area__linked-file-name">{{ file.name }}</span>
                </div>
            </div>
        }
    </div>

    @if (selectedFiles().length > 0) {
        <div class="document-link-area__toolbar">
            <span class="document-link-area__toolbar-count">{{ selectedFiles().length }} kijelölve</span>
            <div class="document-link-area__toolbar-actions">
                <button class="document-link-area__action-icon" title="Megnyitás a fájlkezelőben" [disabled]="!canNavigate()" (click)="navigateSelected()">
                    <app-svg-icon name="crosshair" [size]="20" />
                </button>
                <button class="document-link-area__action-icon" [title]="canPreview() ? 'Megtekintés' : 'Csak egy fájl tekinthető meg egyszerre'" [disabled]="!canPreview()" (click)="previewSelected()">
                    <app-svg-icon name="eye" [size]="20" />
                </button>
                <button class="document-link-area__action-icon" title="Kapcsolat törlése" (click)="confirmMassUnlink()">
                    <app-svg-icon name="unlink" [size]="22" />
                </button>
            </div>
        </div>
    }
    </div>
} @else {
    <div class="document-link-area__no-selection">
        <div class="document-link-area__no-selection-banner">
            <i class="pi pi-exclamation-triangle document-link-area__banner-icon"></i>
            <span>Nincs kategória kiválasztva!</span>
        </div>
    </div>
}

<p-confirmDialog />
